// #/services/workspaces/updateWorkspaceNode.ts
import { INode, IWorkspace, workflowFromWorkspace } from '#/types/workspace';
import updateWorkflow from '../../workflows/updateWorkflow';
import getWorkspace from '../getWorkspace';
import updateWorkspace from '../updateWorkspace';

function mergeUpdatedNode(args: {
  workspace: IWorkspace;
  node: Partial<INode>;
}): IWorkspace {
  const { workspace, node } = args;
  const { position, data: nodeData } = node;

  const nodes = workspace.nodes ?? [];

  const updatedNode = {
    ...(nodes.find((n) => n.data.uuid === nodeData!.uuid) ?? {}),
    ...(node ?? {}),
    position: position ? position : {},
    data: nodeData ? nodeData : {},
  };

  return {
    ...workspace,
    nodes: [
      ...(nodes.filter((n) => n?.data?.uuid !== nodeData!.uuid) ?? []),
      updatedNode,
    ],
    updatedAt: new Date().toISOString(),
  };
}

export default async function updateWorkspaceNode(args: {
  ownerAddress: string;
  workspaceUuid: string;
  updatedWorkspaceNode: Partial<INode>;
}): Promise<boolean> {
  try {
    const { ownerAddress, workspaceUuid, updatedWorkspaceNode } = args;

    const currentWorkspace = await getWorkspace({
      ownerAddress,
      workspaceUuid,
    });

    const updatedWorkspace = mergeUpdatedNode({
      workspace: currentWorkspace,
      node: updatedWorkspaceNode,
    });

    await updateWorkspace({
      ownerAddress,
      workspaceUuid,
      updatedWorkspace,
    });

    await updateWorkflow({
      ownerAddress,
      workflowUuid: workspaceUuid,
      updatedWorkflow: workflowFromWorkspace(updatedWorkspace),
    });

    return true;
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error updating workspace node: ${error.message}`);
  }
}
